import { Injectable } from '@angular/core';

import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { cartIdKey, WebStorageService } from '../services/web-storage/web-storage-service';

@Injectable()
export class CartIdToHeaderInterceptor implements HttpInterceptor {
  constructor(private webStorageService: WebStorageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerName = 'CART-ID';
    const cartId = this.webStorageService.getString(cartIdKey);
    if (cartId && !request.headers.has(headerName)) {
      request = request.clone({ headers: request.headers.set(headerName, cartId) });
    }
    return next.handle(request);
  }
}

export let CartIdToHeaderInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: CartIdToHeaderInterceptor,
  multi: true
};
